import { Box, BoxProps, Button, FormControl, FormLabel, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Textarea } from "@chakra-ui/react";
import { APPICONS } from "../Icons";
import { useEffect, useState } from "react";
import { useKonyveloApi } from "../store/konyvelo.api";
import { useWSysHub, useWSysPath, WSysHubDisplay } from "@coimbra-its/websys-ux-core";


export interface BeszlaJovahagyProps extends Omit<BoxProps, 'children'> {
    DOKID: number;
}


export function BeszlaJovahagy({ DOKID, ...rest }: BeszlaJovahagyProps) {

    const api = useKonyveloApi();
    const [showConfirm, setShowConfirm] = useState<null | 'yes' | 'no'>(null);

    const beszlaIdJovahagyPost = api.beszlaIdJovahagyPost.useAction();
    const hub = useWSysHub();

    const  path = useWSysPath();

    const doJovahagyas = (yesno: 'yes' | 'no') => {
        hub.tryCatch(async () => {
            //if (!megjegyzes) throw "Nincs megjegyzés!!"
            await beszlaIdJovahagyPost({ id: DOKID, yesno, megjegyzes });
            setShowConfirm(null);
            path.parent.close();
        });
    }

    const [megjegyzes, setMegjegyzes] = useState('');
    useEffect(() => {
        setMegjegyzes('');
    }, [showConfirm]);

    return <>
        <Box
            display='flex' flexDir='row' alignItems='center' justifyContent='stretch' gap={2}
            {...rest}>
            {/*OSZAMLA_IMPORT === 'N' && 'Kézzel rögzítve'*/}
            <Button flex={1} colorScheme='green' onClick={() => setShowConfirm('yes')} ><Icon as={APPICONS.Check} />&nbsp;Jóváhagyás</Button>
            <Button flex={1} colorScheme='red' variant='solid' onClick={() => setShowConfirm('no')} ><Icon as={APPICONS.Cancel} />&nbsp;Elutasítás</Button>
        </Box>


        <Modal isOpen={showConfirm !== null} onClose={() => setShowConfirm(null)}>
            <ModalOverlay />
            <ModalContent position='relative'>
                <WSysHubDisplay hubs={[hub]}>
                    <ModalHeader>{showConfirm==='yes'?"Jóváhagyja a számlát?":"Elutasítja a számlát?"}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormControl>
                            <FormLabel>Megjegyés:</FormLabel>
                            <Textarea value={megjegyzes} onChange={e => setMegjegyzes(e.currentTarget.value)} />
                        </FormControl>

                    </ModalBody>

                    <ModalFooter>
                        <Button mr={3} onClick={() => setShowConfirm(null)}><Icon as={APPICONS.Cancel} />&nbsp;Mégsem</Button>
                        {showConfirm === 'yes' && <Button colorScheme='green' mr={3} onClick={() => doJovahagyas('yes')}><Icon as={APPICONS.Check} />&nbsp;Jóváhagyás</Button>}
                        {showConfirm === 'no' && <Button colorScheme='red' mr={3} onClick={() => doJovahagyas('no')}><Icon as={APPICONS.Cancel} />&nbsp;Elutasítás</Button>}
                    </ModalFooter>
                </WSysHubDisplay>
            </ModalContent>
        </Modal>

    </>
}